export const detailInfo = [
  {
    field: 'recordCode',
    'title': '病案编号',
    'language_key': 'efc_ocn_medical_medical_record__record_code',
  },
  {
    field: 'animalId_dictText',
    'title': '动物',
    'language_key': 'efc_ocn_medical_medical_record__animal_id',
  },
  {
    field: 'recordDate',
    'title': '发病日期',
    'language_key': 'efc_ocn_medical_medical_record__record_date',
  },
  {
    field: 'diseaseType_dictText',
    'title': '疾病科别',
    'language_key': 'efc_ocn_medical_medical_record__disease_type',
  },
  {
    field: 'endDate',
    'title': '结案日期',
    'language_key': 'efc_ocn_medical_medical_record__end_date',
  },
  {
    field: 'recordStatus_dictText',
    'title': '当前状态',
    'language_key': 'efc_ocn_medical_medical_record__record_status',
  },
]